<template>
    <div>
        <h3 class="text-2xl text-dark mb-4 font-bold">
            Browse by manufacturer
        </h3>

        <p class="mb-4">Find reviews for your vehicles make and model</p>

        <div class="grid grid-cols-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 items-center"
             v-if="manufacturers.length > 0">
            <a v-for="manufacturer of manufacturers"
               :href="route('manufacturers.show', manufacturer)"
               class="flex items-center group">
                <div class="w-16 h-16 bg-contain bg-no-repeat bg-center mr-4"
                     :style="{backgroundImage: `url(${manufacturer.image})`}"></div>

                <span class="hidden sm:block group-hover:text-primary group-hover:underline">{{
                        manufacturer.name
                    }}</span>
            </a>

            <a :href="route('manufacturers.index')">
                <app-button type="button" size="small">View all</app-button>
            </a>
        </div>
    </div>
</template>

<script setup>
import {onMounted, ref, computed} from "vue";
import AppButton from "@/Components/AppButton";

const manufacturers = ref([]);

const getManufacturers = async () => {
    const response = await axios.get(route("manufacturers.featured"));
    manufacturers.value = response.data;
};

onMounted(() => getManufacturers());
</script>

<style scoped>

</style>
